export enum VehiculosDirectiva {
  NO_CVD = 40567,
  VEH_ACQ = 40568,
  OTH_SERV_CONT = 40569,
  PASS_TRAN_SERV = 40570
}
